import { render, staticRenderFns } from "./Semantic.vue?vue&type=template&id=1fa96f1d&scoped=true"
import script from "./Semantic.vue?vue&type=script&lang=js"
export * from "./Semantic.vue?vue&type=script&lang=js"
import style0 from "./Semantic.vue?vue&type=style&index=0&id=1fa96f1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa96f1d",
  null
  
)

export default component.exports